'use client';

import { SocialLink } from '@/lib/types';
import { createRandomId } from '@/lib/utils';
import { SocialMediaIcon } from '@/ui';
import { Flex, Skeleton } from '@mantine/core';
import useSWR from 'swr';

export function SocialMediaLinks() {
  const { data, isLoading } = useSWR<{ value: SocialLink[] }>(['/authorities/main/get-socials']);

  return (
    <div className="flex items-center justify-start md:justify-center flex-wrap gap-[1rem] w-auto md:w-full">
      {isLoading
        ? Array.from({ length: 5 }, () => <Skeleton key={createRandomId()} width={32} height={32} circle />)
        : data?.value?.map((item) => (
            <SocialMediaIcon
              key={item?.link}
              type={item?.type}
              url={item?.link}
              variant="secondary"
              position="bottom"
              circle
            />
          ))}
    </div>
  );
}
